import { render, staticRenderFns } from "./DDT_StatisticsWindow.vue?vue&type=template&id=03475826&"
import script from "./DDT_StatisticsWindow.vue?vue&type=script&lang=js&"
export * from "./DDT_StatisticsWindow.vue?vue&type=script&lang=js&"
import style0 from "./DDT_StatisticsWindow.vue?vue&type=style&index=0&id=03475826&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports